import React, { FC } from 'react';
import { BookingsGroup } from '../../../../../../../types';
import BookingBodyContentRow from './BookingBodyContentRow';
import { BookingBodyContentDataHooks } from '../../../../datahooks';
import { classes } from './BookingBodyContent.st.css';

export interface BookingBodyContentProps {
  group: BookingsGroup;
}

const BookingBodyContent: FC<BookingBodyContentProps> = ({ group }) => {
  const withServiceName = group.bookings.length > 1;

  const rows = group.bookings.map((booking, index) => {
    return (
      <div className={classes.item} data-hook={BookingBodyContentDataHooks.Row}>
        <BookingBodyContentRow
          key={booking.bookingId}
          booking={booking}
          withServiceName={withServiceName}
        />
      </div>
    );
  });

  return (
    <div className={classes.root} data-hook={BookingBodyContentDataHooks.Main}>
      {rows}
    </div>
  );
};

export default BookingBodyContent;
